import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';
import { LicenseMainFormGzDataProvider } from '../dataProvider/LicenseMainFormGzDataProvider';

export class LicenseMainFormDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, LicenseMainFormGzDataProvider);
  }
}
